"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  forgotWorkspacePasswordDialog: {
    "id": "forgotWorkspacePasswordDialog",
    "defaultMessage": "Forgot workspace password"
  },
  contactAdmin: {
    "id": "contactAdmin",
    "defaultMessage": "Contact your workspace admin for your workspace password."
  },
  returnToSignIn: {
    "id": "returnToSignIn",
    "defaultMessage": "Return to sign in"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map